module.exports = __webpack_public_path__ + "static/media/calendar.462e5fef.svg";